module.exports = __webpack_public_path__ + "img/chat_bookmark_active.5fa25ac7.svg";